import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon } from 'lucide-react';
import { BRAND } from './salesData';
const CONTACTS = [{
  icon: MailIcon,
  label: 'Soporte y consultas',
  value: BRAND.email,
  href: `mailto:${BRAND.email}`,
  external: false
}, {
  icon: InstagramIcon,
  label: 'Instagram',
  value: BRAND.instagramHandle,
  href: BRAND.instagramUrl,
  external: true
}, {
  icon: GlobeIcon,
  label: 'Sitio oficial',
  value: BRAND.siteLabel,
  href: BRAND.siteUrl,
  external: true
}];
export function Footer() {
  return <footer id="site-footer" className="border-t border-warm bg-bone py-12" data-id="element-142" data-mp="3lec7k9t840dr">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-143" data-mp="3lggez1qbzhis">
        <div className="flex flex-col gap-8 sm:flex-row sm:items-start sm:justify-between sm:gap-12" data-id="element-144" data-mp="3qc40961ozqj0">
          <div data-id="element-145" data-mp="29ydxq3q81abh">
            <p className="font-display text-[1.3rem] tracking-tight text-charcoal" data-id="element-146" data-mp="29xvrqfdrbhqd">
              100 <span className="text-gold-deep" data-id="element-147" data-mp="2ezutjktum6l7">NY</span> Cookies
            </p>
            <p className="mt-1.5 font-sans text-[0.86rem] text-charcoal/55" data-id="element-148" data-mp="3lalfndz543tf">
              Para fabricar y vender · Producto 100% digital
            </p>
            <p className="mt-5 font-sans text-[0.6rem] font-bold uppercase tracking-editorial text-charcoal/40" data-id="element-149" data-mp="3gctmyhqo8do6">
              Un producto de
            </p>
            <p className="mt-1 font-display text-[1.05rem] tracking-tight text-charcoal" data-id="element-150" data-mp="3q7ty7fo7a9v7">
              {BRAND.studio}
            </p>
          </div>

          <ul className="grid gap-4 sm:grid-cols-3 sm:gap-x-10" data-id="element-151" data-mp="3474tnw649z9">
            {CONTACTS.map(contact => {
            const Icon = contact.icon;
            return <li key={contact.href} data-id="element-152" data-mp="huwgsshgdt46">
                  <p className="font-sans text-[0.6rem] font-bold uppercase tracking-editorial text-charcoal/40" data-id="element-153" data-mp="ct783jhpdrj9">
                    {contact.label}
                  </p>
                  <a href={contact.href} {...contact.external ? {
                target: '_blank',
                rel: 'noopener noreferrer'
              } : {}} className="mt-1.5 inline-flex items-center gap-2 font-sans text-[0.88rem] font-medium text-charcoal/75 transition-colors duration-200 ease-out hover:text-gold-deep" data-id="element-154" data-mp="mrwp7a1rz7yg">
                    <Icon className="h-4 w-4 shrink-0 text-gold-deep" aria-hidden data-id="element-155" data-mp="18jr0fxbebjt2" />
                    <span className="break-all" data-id="element-156" data-mp="18lu2jfptp3e5">{contact.value}</span>
                  </a>
                </li>;
          })}
          </ul>
        </div>

        <div className="mt-10 border-t border-warm pt-6" data-id="element-157" data-mp="1hj4c8wmzskgy">
          <p className="max-w-3xl font-sans text-[0.74rem] leading-relaxed text-charcoal/40" data-id="element-158" data-mp="1mj8vgufabtav">
            100 New York Cookies es un producto digital de recetas y fundamentos de fabricación. Los
            resultados comerciales dependen de la ejecución y del mercado de cada persona. Antes de
            vender alimentos elaborados, verificá las normas que correspondan en tu ciudad o país.
          </p>
          <p className="mt-4 font-sans text-[0.74rem] text-charcoal/40" data-id="element-159" data-mp="2afdhlagc14nq">
            © 2026 {BRAND.studio}. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}